import React from "react";
import { Identifiable, Discussion as D } from "@planzone/dto";
import { Flag, InfiniteScroll } from "@common/infiniteScroll";
import { Props } from "./types";
import { Discussion } from "./discussion";
import { Discussion as DiscussionSkeleton } from "../loader/discussion";
import styles from "./styles.scss";

function hasComments(discussion: Identifiable<D>) {
  return (discussion.commentsCount ?? discussion.comments.length) > 0;
}

function Discussions({
  project,
  discussions,
  resources,
  isRequestPending,
  canLoadMore,
  loadNextPage,
}: Props) {
  return (
    <InfiniteScroll className={styles.discussions} canFetchOnIdle={canLoadMore}>
      {() => (
        <>
          {discussions.filter(hasComments).map((discussion) => (
            <div className={styles.discussion} key={discussion.uuid}>
              <Discussion
                project={project}
                discussion={discussion}
                resources={resources}
              />
            </div>
          ))}
          {isRequestPending && (
            <>
              <DiscussionSkeleton />
            </>
          )}
          <Flag
            name="discussionsFlag"
            retrieveItems={loadNextPage}
            isDisabled={isRequestPending || !canLoadMore}
          />
        </>
      )}
    </InfiniteScroll>
  );
}

export { Discussions };
